<app-tabs [tabs]="tabs" [activeTab]="activeTab"  [tabIdPrefix]="'queues'"
  [containerClass]="'my-applications-container'" (tabSelected)="onTabSelected($event)">
    <ng-container [ngSwitch]="activeTab">
        <app-audit-trails *ngSwitchCase="'audit_trails'"></app-audit-trails>
        <app-business-rules *ngSwitchCase="'business_rules'"></app-business-rules>
         <app-data-template *ngSwitchCase="'data_template'"></app-data-template>
        <app-content-management *ngSwitchCase="'content_management'"></app-content-management>
        <!-- <app-emails *ngSwitchCase="'emails'"></app-emails>
        <app-text-management *ngSwitchCase="'text_management'"></app-text-management>
        <app-ticker *ngSwitchCase="'ticker'"></app-ticker> -->
    </ng-container>
</app-tabs>